import { APP_DEFAULT_PATH_MY } from 'config';
import useAuth from 'hooks/useAuth';
import useOrganization from 'hooks/useOrganization';
import { GuardProps } from 'types/auth';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AuthGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, logout, person } = useAuth();
  const { organization, setCurrentOrganization, deleteCurrentOrganization } = useOrganization();
  const LocalStorageOrganizationId = window.localStorage.getItem('0paper-current-organization');
  const navigate = useNavigate();
  const location = useLocation();

  const doesNotHaveOrganization = !organization && !LocalStorageOrganizationId;
  const loggedInWithoutOrganization = isLoggedIn && doesNotHaveOrganization;
  const loggedInWithOrganization = organization && isLoggedIn;
  const loggedOutWithoutOrganization = !isLoggedIn && doesNotHaveOrganization;
  const loggedOutWithOrganization = organization && !isLoggedIn;
  const isJuridicPerson = person?.user.personable_type === 'JuridicPerson';
  const hasMoreThanOneOrganization = person?.organization_users && person?.organization_users?.length >= 2;
  const userRequesterOrganization = person?.organization_users?.find(
    ({ organization_id, permission }) => organization_id === organization?.id && permission !== 'requester'
  );
  const userOrganization = person?.organization_users?.find(({ organization_id }) => organization_id === organization?.id);
  const current_user_organization = hasMoreThanOneOrganization ? userRequesterOrganization : userOrganization;
  const isUserRequester = current_user_organization && current_user_organization.permission === 'requester';

  useEffect(() => {
    switch (true) {
      case loggedOutWithoutOrganization:
        deleteCurrentOrganization();
        break;
      case loggedInWithOrganization && !LocalStorageOrganizationId:
        if (organization) {
          setCurrentOrganization(organization.id);
        }
        break;
      case loggedInWithoutOrganization:
        logout();
        break;
      case loggedOutWithOrganization:
        if (organization) {
          navigate(`/organization/${organization.id}/login`);
        } else {
          navigate('/organization-select');
        }
        break;
      case !isLoggedIn:
        navigate('/organization-select');
        break;
      case isJuridicPerson:
        navigate(APP_DEFAULT_PATH_MY);
        break;
      case isUserRequester || !current_user_organization:
        navigate(APP_DEFAULT_PATH_MY);
        break;
      default:
        navigate(location.pathname);
        break;
    }
  }, []);

  return children;
};

export default AuthGuard;
